export const DHKS_INFO = {
  companyEGName: "DHK Solution",
  companyKRName: "디에이치케이솔루션",
  contact: {
    main: {
      address: `경기도 성남시 분당구 판교로 255번길 28 (삼평동,
                  디에이치케이솔루션빌딩)`,
      tel: "031-639-9000",
      fax: "031-639-9035",
    },
  },
};
